class PropertyDeliveries {
    items;
    constructor(crowdfundingDeliveries) {
        this.items = crowdfundingDeliveries.map(delivery => ({
            ...delivery,
            date: new Date(delivery.date)
        }));
    }
}
export default PropertyDeliveries;
